"use client";

import { Box, Grid } from "@mui/material";
import { WorkPlaceCreationPopup } from "./WorkPlaceCreationPopup";
import WorkPlacesList from "./WorkPlacesList";
import WorkPlacesMap from "./WorkPlacesMap";
import LikeSpotButton from "../../spots/components/LikeSpotButton";

export const WorkPlaces = ({ id }) => {
  return (
    <>
      {" "}
      <Grid item lg={7} xs={12} id="workPlacesLists" minHeight={500}>
        <Grid
          item
          container
          justifyContent={{ xs: "space-between", sm: "flex-end" }}
          alignItems="center"
          sx={{
            mb: 2,
            paddingRight: 2,
            minHeight: "40px", // Ensure consistent container height
          }}
        >
          {/* Show like button on mobile (xs) only, positioned on the left */}
          <Box
            sx={{
              display: { xs: "flex", sm: "none" },
              alignItems: "center",
              justifyContent: "flex-start",
              height: "40px", // Match typical button height
            }}
          >
            <LikeSpotButton id={id} />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              height: "40px", // Match typical button height
            }}
          >
            <WorkPlaceCreationPopup id={id} />
          </Box>
        </Grid>

        <WorkPlacesList type="café" spotId={id} />
        <WorkPlacesList type="coworking" spotId={id} />
        <WorkPlacesList type="coliving" spotId={id} />
      </Grid>
      <Grid item container xs={12} lg={5}>
        <WorkPlacesMap id={id} />
      </Grid>
    </>
  );
};
